/*
  Keeping two side-by-side scroll boxes in step.

  My Customers draws its column headings and its rows in separate cards, and
  below 1000px each card is its own horizontally scrolling box -- they have to
  be, because only the card can carry the scrollbar. Left alone that is two
  scrollbars moving independently, so dragging the rows slides the data out from
  under its own headings.

  Merging them into one scroller would be simpler, but it would drag the search
  field and the invite button into the scroll region with them, and those belong
  where they are.
*/

/*
  Copy one box's horizontal position onto the other.

  Returns a scroll handler. The guard is the whole point: assigning scrollLeft
  fires a scroll event on the box being assigned to, whose own handler comes
  straight back here. Comparing first means the second pass finds them equal and
  stops, instead of the two boxes handing the event back and forth forever.
*/
export const syncScrollLeft = (fromRef, toRef) => () => {
  const source = fromRef && fromRef.current;
  const target = toRef && toRef.current;
  if (!source || !target) return;
  if (target.scrollLeft !== source.scrollLeft)
    target.scrollLeft = source.scrollLeft;
};
